import React, { forwardRef, MouseEvent } from 'react';
import { iconList } from '@components-library/Icons/constants';
import { IBaseIconProps } from '@components-library/Icons/interfaces';
import cn from 'classnames';
import styles from './icon.module.scss';
import './sizeClassName.scss';

/**
 * @deprecated
 * The component is made for backwards compatibility with the Font Awesome library.
 * Will be removed after new icons are approved by business and added to assets.
 * You can use the current available icons or use the SVGIcon component to add new ones.
 */

export const DeprecatedFAIcon = forwardRef<SVGSVGElement, IBaseIconProps>(({ icon, className, size, onClick }, ref) => {
  const iconProp = iconList[icon];

  const onIconClick = (e: MouseEvent<SVGSVGElement>) => onClick?.(e);

  const getViewBox = (width: number, height: number) => {
    return `0 0 ${width} ${height}`;
  };

  const widthClassName = `fa-w-${Math.ceil((iconProp.width / iconProp.height) * 16)}`;

  const sizeClassName = size ? 'fa-'.concat(size) : '';

  return (
    <svg
      onClick={onIconClick}
      ref={ref}
      className={cn('svg-icon-fa', styles.icon, className, sizeClassName, widthClassName)}
      viewBox={getViewBox(iconProp.width, iconProp.height)}>
      <path fill="currentColor" d={iconProp.path} />
    </svg>
  );
});
